import React from "react";

const OnIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.17518 3.50977C3.66757 3.93611 3.25414 4.46333 2.96115 5.05797C2.66817 5.65261 2.50202 6.30168 2.47325 6.96396C2.44449 7.62623 2.55374 8.28726 2.79408 8.90506C3.03441 9.52286 3.40057 10.0839 3.86931 10.5527C4.33806 11.0214 4.89914 11.3876 5.51694 11.6279C6.13475 11.8683 6.79577 11.9775 7.45805 11.9488C8.12033 11.92 8.76939 11.7538 9.36403 11.4609C9.95867 11.1679 10.4859 10.7544 10.9122 10.2468"
        stroke="#15803D"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6353 3.73092C11.1062 4.19752 11.4749 4.75692 11.718 5.37362C11.9612 5.99032 12.0734 6.65084 12.0477 7.31324C12.022 7.97564 11.8588 8.62546 11.5685 9.22143C11.2782 9.8174 10.8672 10.3465 10.3616 10.7752C9.85591 11.2038 9.26664 11.5227 8.63119 11.7114C7.99573 11.9002 7.32797 11.9548 6.67029 11.8717C6.01261 11.7887 5.37939 11.5697 4.81083 11.2289C4.24226 10.8881 3.75078 10.4327 3.36758 9.8918"
        stroke="#15803D"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.27344 1.29883V3.42408"
        stroke="#15803D"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default OnIcon;
